import * as React from "react"
import { Link, withRouter } from 'react-router-dom';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { Grid } from "../ecosystem/";
import { BannerCard, LandingCard, PageHeading } from "../ecosystem/mybswh";

const HealthSummaryLanding = (props) => {

    const onClickhealthSummaryTile = (tileName, routeName) => {
        logUI(`MBHWeb.UI.HealthSummaryLanding.${tileName}.Clicked`, new Date(), Tools.getURLPath());
        if (routeName) {
            props.history.push(routeName);
        }
    };
    const subHeading = 'The Health Summary provides you with a convenient summary of important information in your health record. Your summary includes up-to-date information concerning your current health issues, medications, allergies, immunizations, and preventive care.';
    const pageHeading = `Health Summary`;

    const { isMyChartUser, disableMyChartMenuItems } = Tools.handleMychartUserShowOrHideMenuItems();
    const { proxyName } = Tools.getProxyName();

    const landingItems = [
        {
            title: "Current Health Issues",
            body: "Review your current health issues and update them as needed.",
            to: "/currentissues",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => {
                onClickhealthSummaryTile("healthissues");
            }
        },
        {
            title: "Allergies",
            body: "Review your allergies and update them as needed.",
            to: "/allergies",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => {
                onClickhealthSummaryTile("allergies");
            }
        },
        {
            title: "Immunizations",
            body: "Review your immunization history and document immunizations you've received elsewhere, such as at a flu shot clinic.",
            to: "/immunizations",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => {
                onClickhealthSummaryTile("immunizations");
            }
        },
        {
            title: "Preventive Care",
            body: "Keep track of routine care that is due and receive reminders for flu shots and other immunizations, physical exams and preventive care procedures.",
            to: "/todo",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => {
                onClickhealthSummaryTile("preventativecare");
            }
        },
        {
            title: "Medical and Family History",
            body: "This is an overview of your medical and family history on file with the clinic.",
            to: "/medicalhistory",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => {
                onClickhealthSummaryTile("medicalhistory");
            }
        },
        {
            title: "Plan of Care",
            body: "A centralized place to manage your care by pulling together your goals and to do items you need to track and follow up on.",
            to: "/planofcare",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => {
                onClickhealthSummaryTile("planofcare");
            }
        }
    ];

    return (
        <Grid className="body-content body-content--no-top-offset body-content--bg-gray health-summary-landing-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading
                        bodyOffset
                        heading={pageHeading}
                        proxyName={proxyName}
                        description={subHeading}
                    />

                    <div className="row">
                        {
                            landingItems.map((item, i) => {
                                return item.show ? (
                                    <div className="col-12 col-lg-4">
                                        <LandingCard {...item} />
                                    </div>
                                ) : null
                            })
                        }
                    </div>
                    {isMyChartUser && 
                        <div className="row banner-card-row">
                            <div className="col-12 col-lg-12">
                                <BannerCard
                                    title="Did you know?"
                                    body={
                                        <span>You can share portions of your Health Summary with your doctor via{' '}
                                            {disableMyChartMenuItems
                                                ? <strong>Share Everywhere®</strong>
                                                : <Link
                                                    to="/shareeverywhere"
                                                    onClick={() => { onClickhealthSummaryTile("shareeverywhere") }}
                                                >
                                                    Share Everywhere®
                                                </Link>
                                            }
                                        </span>
                                    }
                                    cardIcon={{ name: 'chat-visit', set: 'brand' }}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </Grid>

    )
}

export default HealthSummaryLanding;
